import {create} from 'zustand';

// Zustand Store zur Speicherung des Gesamtumsatzes, der Gesamtkosten und des Gesamtrohertrags
const useRevenueStoreMonth = create((set) => ({
    totalRevenue: 0,
    totalCosts: 0,
    totalYield: 0,

    // Setzt den Gesamtumsatz
    setTotalRevenue: (revenue) => {
        set({totalRevenue: revenue});
    },

    // Setzt die Gesamtkosten
    setTotalCosts: (costs) => {
        set({totalCosts: costs});
    },

    // Setzt den Gesamtrohertrag (Yield)
    setTotalYield: (yieldValue) => {
        set({totalYield: yieldValue});
    },
}));

export default useRevenueStoreMonth;